import { createContext } from 'react';

import { SearchProviderContextValue } from './SearchContextProvider.types.ts';

export const SearchContextProviderContext = createContext<SearchProviderContextValue | undefined>(undefined);
